var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-box",staticStyle:{"margin-top":"50px"}},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('Editor',{attrs:{"type":'html'}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }